import styled from "styled-components";

export const CmpInfoContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 21px;
`;

export const CmpInfoContentLayout = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
`;

export const CmpInfolongQuest = styled.div`
  width: 100%;
  span {
    color: ${(props) => [props.theme.colors.primary]};
    font-weight: 700;
  }
  font-size: 2.2rem;
  font-weight: 600;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
`;

export const CmpContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 12px;
`;

export const CmpExplanBox = styled.div`
  width: 100%;
  align-items: center;
  padding: 4px;
  border: 5px solid ${(props) => props.theme.colors.cameraBg};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.cameraBg};
  font-size: 1.2rem;
  text-align: center;
  color: ${(props) => props.theme.colors.labelTxt};
  flex-shrink: 0;
`;

export const CmpCameraBox = styled.div`
  width: 100%;
  align-items: center;
  padding: 70px;
  border: 5px solid ${(props) => props.theme.colors.cameraBg};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.cameraBg};
  font-size: 2.2rem;
  text-align: center;
  color: ${(props) => props.theme.colors.labelTxt};
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

export const CmpUploadButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: end;
  gap: 6px;
  flex-shrink: 0;

  .row-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 6px;

    button {
      width: 100%;
      border: 1px solid ${(props) => props.theme.colors.primary};
    }
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const CmpImgBox = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-height: 100%;
  }

  @media (max-width: 360px) {
    min-height: 150px;
  }
`;

export const ImgLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
`;

export const ContentMainLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
`;
